import { useContext } from 'react';
import AuthContext from '../AuthContext';
import { doSignIn } from '../utils/reducers';

export default function useSignIn() {
    var context = useContext(AuthContext);
    if (context === null) {
        throw new Error("No AuthContext");
    }
    return function (signInConfig) {
        var token = signInConfig.token, tokenType = signInConfig.tokenType, authState = signInConfig.authState, expiresIn = signInConfig.expiresIn;
        var expTime = new Date(new Date().getTime() + expiresIn * 60 * 1000);
            // sign in without the refresh token
            context.dispatch(doSignIn({
                auth: {
                    token: token,
                    type: tokenType,
                    expiresAt: expTime,
                },
                userState: authState ? authState : null,
                refresh: null,
            }));
            return true;
    };
}